import { ScheduleItem, Doctor, Staff, Room } from './SchedulerTypes';
import { ScheduleLogsTable as ModularScheduleLogsTable } from './ScheduleLogs';

interface ScheduleLogsTableProps {
  scheduleItems: ScheduleItem[];
  doctors: Doctor[];
  staff: Staff[];
  rooms: Room[];
  onEditScheduleItem: (item: ScheduleItem) => void;
  onDeleteScheduleItem: (id: string) => void;
}

// This file is now a wrapper for the refactored modular component
const ScheduleLogsTable = (props: ScheduleLogsTableProps) => {
  return <ModularScheduleLogsTable {...props} />;
};

export default ScheduleLogsTable;